import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ProjectCard.css';

export function ProjectCard({ title, subtitle, year, description, imageSrc, link, buttonText }) {
  const navigate = useNavigate();
  const isExternal = /^(https?:)?\/\//i.test(link);

  const handleCardClick = () => {
    if (isExternal) {
      window.open(link, '_blank', 'noopener,noreferrer');
      return;
    }

    navigate(link);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCardClick();
    }
  };

  const ButtonLink = isExternal ? 'a' : Link;
  const buttonProps = isExternal
    ? { href: link, target: '_blank', rel: 'noopener noreferrer' }
    : { to: link };

  return (
    <article
      className="project-card"
      role="link"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
    >
      <div className="card-content">
        <div className="card-header">
          <p className="card-eyebrow">{year}</p>
          <h3 className="card-title">{title}</h3>
          <p className="card-subtitle">{subtitle}</p>
        </div>
        <div className="card-body">
          <div className="card-text">
            <p className="card-description">{description}</p>
            <ButtonLink
              className="card-button"
              {...buttonProps}
              onClick={(event) => event.stopPropagation()}
            >
              {buttonText}
            </ButtonLink>
          </div>
          <div className="card-image">
            <img src={imageSrc} alt={`${title} cover`} loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </article>
  );
}
